import moment from "moment";
import _ from "lodash";
import papaparse from "papaparse";
import { getContrast, getSiteID } from "../visualization/data-management";
import { getPrimaryColorFunc, convertMonthToTimestampsByMonth } from "./utils";

export const lineColor = function() {
  return ["#c4c4c4", getPrimaryColorFunc(), "#a6cee3", "#7891d1", "#56b3b9", "#cab2d6", "#7f69d4", "#fb9a99", "#fdbf6f", "#b5cdd8", "#7F69D5", "#D6B2CE", "#A6CEE3", "#6994D4", "#FB9A99", "#B9DFD1", "#B269D5", "#FDBF6F", "#7893F3", "#83C6A8"];
};

const fusionDefaultForBar = {
  chart: {
    xaxisname: "",
    yaxisname: "",
    animation: "1",
    xAxisNameFontColor: "#959fa4",
    xAxisNameFont: "RobotoMedium",
    xAxisNameFontSize: "9px",
    labelFontSize: "10px",
    labelFont: "RobotoRegular",
    labelFontColor: "#a3a3a3",
    yAxisNameFontColor: "#a3a3a3",
    yAxisNameFont: "RobotoMedium",
    yAxisNameFontSize: "9px",
    yAxisValueFont: "RobotoMedium",
    yAxisValueFontSize: "10px",
    yAxisValueFontColor: "#a3a3a3",
    theme: "fusion",
    legendPosition: "right",
    legendIconSides: "4",
    legendItemFont: "RobotoRegular",
    legendItemFontColor: "#666669",
    legendCaptionAlignment: "center",
    baseFontSize: "10",
    tooltipBorderAlpha: "0",
    showToolTipShadow: "0",
    legendItemFontSize: "10px",
    scrollColor: "#cccccc",
    numVisiblePlot: "20",
    divLineAlpha: "0",
    divLineDashed: "0",
    useEllipsesWhenOverflow: "1",
    maxColWidth: "15",
    plotSpacePercent: 30,
    showXAxisLine: true,
    showYAxisLine: true,
    xaxislinethickness: "1",
    yaxislinethickness: "1",
    xAxisLineColor: "#b0bac9",
    yAxisLineColor: "#b0bac9",
    chartBottomMargin: "0",
    xAxisNamePadding: "5",
    decimals: 0,
    labelDisplay: "wrap",
    maxLabelHeight: "30",
    baseFont: "RobotoRegular",
    baseFontColor: "#ffffff",
    trendValueBgColor: "#696969",
    trendValueBorderPadding: "4",
    trendValueBorderRadius: "2",
    showTrendlinesOnTop: "1"
  },
  categories: [{ category: [] }],
  dataset: [{ data: [] }],
  trendlines: [
    {
      line: []
    }
  ]
};

export const fusionChartCommon = {
  xAxisName: "Time Frame",
  paletteColors: lineColor().join(","),
  yAxisName: "Minutes",
  xAxisNameFontColor: "#959fa4",
  xAxisNameFont: "RobotoMedium",
  xAxisNameFontSize: "9px",
  labelFontSize: "10px",
  labelFont: "RobotoRegular",
  labelFontColor: "#a3a3a3",
  yAxisNameFontColor: "#a3a3a3",
  yAxisNameFont: "RobotoMedium",
  yAxisNameFontSize: "9px",
  yAxisValueFont: "RobotoMedium",
  yAxisValueFontSize: "10px",
  yAxisValueFontColor: "#a3a3a3",
  theme: "fusion",
  legendPosition: "right",
  legendItemFont: "RobotoRegular",
  legendItemFontColor: "#666669",
  legendCaptionAlignment: "center",
  legendItemFontSize: "10px",
  legendIconBgColor: lineColor().join(","),
  legendIconSides: 4,
  legendIconBgAlpha: "100",
  legendIconBorderThickness: "8",
  legendIconScale: "1.1",
  legendItemHiddenColor: "#7B8BA2",
  baseFontSize: "10",
  tooltipBorderAlpha: "0",
  toolTipBgAlpha: "0",
  showToolTipShadow: "0",
  scrollheight: "10",
  divLineAlpha: "0",
  divLineDashed: "0",
  scrollColor: "#cccccc",
  numVisiblePlot: "20",
  showHoverEffect: "1",
  useEllipsesWhenOverflow: "1",
  maxColWidth: "15",
  plotHighlightEffect: "fadeout",
  plotSpacePercent: 30,
  showXAxisLine: true,
  showYAxisLine: true,
  showaxislines: "1",
  xAxisLineColor: "#b0bac9",
  yAxisLineColor: "#b0bac9",
  chartBottomMargin: "0",
  xAxisNamePadding: "5",
  decimals: "0",
  labelDisplay: "wrap",
  maxLabelHeight: "30",
  yAxisValueDecimals: "0",
  numvisibleplot: 0,
  anchorHoverRadius: "6"
};

export function durationOfTelehealthVisitsTooltip(tab, data) {
  if (tab === "total") {
    return (
      '<div class="cancelled-telehealth-visits-tooltip arrow_box" style="background-color: ' +
      getPrimaryColorFunc() +
      ";color: " +
      getContrast(getPrimaryColorFunc()) +
      '">' +
      '<span class="title-tooltip-custom-apex"><b>' +
      data.x.toUpperCase() +
      "</b></span>" +
      '<div class="wrapper-description">' +
      '<div class="description">' +
      "Max: " +
      (data.max < 1 ? Math.round(data.max * 100)/100 : Math.round(data.max)) +
      " mins" +
      "</div>" +
      "</div>" +
      '<div class="wrapper-description">' +
      '<div class="description">' +
      "Avg: " +
      (data.y < 1 ? Math.round(data.y * 100)/100 : Math.round(data.y)) +
      " mins" +
      "</div>" +
      "</div>" +
      '<div class="wrapper-description">' +
      '<div class="description">' +
      "Min: " +
      (data.min < 1 ? Math.round(data.min * 100)/100 : Math.round(data.min)) +
      " mins" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>"
    );
  } else {
    data.index = data.index ? data.index : 0;
    return (
      '<div class="cancelled-telehealth-visits-tooltip arrow_box" style="background-color: ' +
      lineColor()[data.index] +
      ";color: " +
      getContrast(lineColor()[data.index]) +
      '">' +
      '<span class="title-tooltip-custom-apex"><b>' +
      data.x.toUpperCase() +
      "</b></span>" +
      '<div class="wrapper-description">' +
      '<div class="description">' +
      "$seriesName " +
      "</div>" +
      "</div>" +
      '<div class="wrapper-description">' +
      '<div class="description">' +
      "Avg: " +
      (data.y < 1 ? Math.round(data.y * 100)/100 : Math.round(data.y)) +
      " mins" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }
}

// ===================================
// |      Get List All Countries     |
// \=================================|
export function getCountryList(rawData) {
  if (!rawData) {
    return;
  }
  const tmpCountries = Object.keys(rawData);
  return tmpCountries;
}

// ===============================
// |      Get List All Sites     |
// \=============================|
export function getAllSites(rawData) {
  if (!rawData) {
    return;
  }
  const mapSiteCountry = {};
  const tmpSites = [];
  Object.entries(rawData).map(element => {
    Object.entries(element[1]).map(elem => {
      tmpSites.push(elem[0]);
      mapSiteCountry[elem[0]] = element[0];
    });
  });

  return {
    allSites: tmpSites,
    mapSiteCountry
  };
}

function generateToolTextForBar(chosenType, value, label, activeDate, firstDataDate, participantID) {
  let tooltip = "";
  if (chosenType === "fpi") {
    //style="background-color: ${w.globals.markers.colors[seriesIndex]}"
    tooltip =
      value < 0
        ? `<div class="arrow_box" >
        <span class="title-tooltip-custom-apex">${value} Days, ${label}</span>
        <div>
          <div class="description">Activation Date:</div>
          <div class="description-value">${activeDate}</div>
        </div>
        <div>
          <div class="description">First Visit Date:</div>
          <div class="description-value">${firstDataDate}</div>
        </div>
        <div>
          <div class="note-desc">Negative days display when the site activation date is after the site’s first participant first visit date.</div>
        </div>
      </div>`
        : `<div class="arrow_box" >
        <span class="title-tooltip-custom-apex">${value} Days, ${label}</span>
        <div>
          <div class="description">Activation Date:</div>
          <div class="description-value">${activeDate}</div>
        </div>
        <div>
          <div class="description">First Visit Date:</div>
          <div class="description-value">${firstDataDate}</div>
        </div>
      </div>`;
  } else {
    tooltip =
      value < 0
        ? `<div class="arrow_box" >
      <span class="title-tooltip-custom-apex">${value} Days, ${label}</span>
      <div class="wrapper-description">
        <div class="description">Participant ID:</div>
        <div class="description-value-wrap">${participantID}</div>
      </div>
      <div>
        <div class="description">Activation Date:</div>
        <div class="description-value">${activeDate}</div>
      </div>
      <div>
        <div class="description">First Data Date:</div>
        <div class="description-value">${firstDataDate}</div>
      </div>
      <div>
        <div class="note-desc">Negative days display when the site activation date is after the site’s first participant first visit date.</div>
      </div>
    </div>`
        : `<div class="arrow_box" >
      <span class="title-tooltip-custom-apex">${value} Days, ${label}</span>
      <div class="wrapper-description">
        <div class="description">Participant ID:</div>
        <div class="description-value-wrap">${participantID}</div>
      </div>
      <div>
        <div class="description">Activation Date:</div>
        <div class="description-value">${activeDate}</div>
      </div>
      <div>
        <div class="description">First Data Date:</div>
        <div class="description-value">${firstDataDate}</div>
      </div>
    </div>`;
  }
  return tooltip;
}
export const wrangleSiteRecruitmentData = async (filteredRawData, chosenType = "fpi", fromDate = null, toDate = null, isSiteStaff = false) => {
  const filteredData = filteredRawData;
  const barData = _.cloneDeep(fusionDefaultForBar);
  barData.chart.paletteColors = getPrimaryColorFunc();
  barData.chart.toolTipBgColor = getPrimaryColorFunc();
  barData.chart.toolTipColor = "#ffffff";
  let totalFpiSum = 0;
  let totalFirstDataSum = 0;
  let totalValidSites = 0;
  let includesInDateFilter = false;

  let activeDate = [];
  let firstDataDate = [];
  let participantIDs = [];

  const data = [];
  // Fill into each datasets
  for (const country in filteredData) {
    for (const site in filteredData[country]) {
      includesInDateFilter = false;
      const siteName = site;
      const siteInfo = filteredData[country][site];
      if (siteInfo) {
        const momentActiveDate = moment(siteInfo.active).startOf("day");
        const momentFpiDate = moment(siteInfo.fpi).startOf("day");
        const momentFirstDataDate = moment(siteInfo.firstData).startOf("day");
        const daysFpi = momentFpiDate.diff(momentActiveDate, "days");
        const daysFirstData = momentFirstDataDate.diff(momentActiveDate, "days");

        if ((chosenType === "firstData" && isNaN(daysFpi)) || (chosenType === "firstData" && isNaN(daysFirstData))) {
          continue;
        }

        activeDate.push(momentActiveDate);
        firstDataDate.push(chosenType === "fpi" ? momentFpiDate : momentFirstDataDate);
        participantIDs.push(siteInfo.firstDataParticipant);

        if (fromDate) {
          includesInDateFilter = momentActiveDate.isBetween(fromDate, toDate, "days", "[]");
          if (includesInDateFilter && chosenType === "firstData" && !isNaN(daysFirstData)) {
            includesInDateFilter = includesInDateFilter && momentFirstDataDate.isBetween(fromDate, toDate, "days", "[]");
          } else if (includesInDateFilter && chosenType === "fpi" && !isNaN(daysFpi)) {
            includesInDateFilter = includesInDateFilter && momentFpiDate.isBetween(fromDate, toDate, "days", "[]");
          }
          if (!includesInDateFilter) {
            continue;
          }
        }

        let siteIncluded = false;
        if (!isNaN(daysFpi)) {
          totalFpiSum += daysFpi;
          siteIncluded = true;
        }
        if (!isNaN(daysFirstData)) {
          totalFirstDataSum += daysFirstData;
          siteIncluded = true;
        }
        totalValidSites = siteIncluded ? totalValidSites + 1 : totalValidSites + 0;

        // apex chart
        if (chosenType === "fpi") {
          barData.dataset[0].data.push({
            value: isNaN(Number(daysFpi)) ? 0 : daysFpi,
            toolText: generateToolTextForBar(
              chosenType,
              isNaN(Number(daysFpi)) ? 0 : daysFpi,
              siteName,
              moment(momentActiveDate)
                .format("DD MMM YYYY")
                .toString()
                .toUpperCase(),
              moment(chosenType === "fpi" ? momentFpiDate : momentFirstDataDate)
                .format("DD MMM YYYY")
                .toString()
                .toUpperCase(),
              siteInfo.firstDataParticipant
            )
          });
        } else {
          barData.dataset[0].data.push({
            value: isNaN(Number(daysFirstData)) ? 0 : daysFirstData,
            toolText: generateToolTextForBar(
              chosenType,
              isNaN(Number(daysFpi)) ? 0 : daysFpi,
              siteName,
              moment(momentActiveDate)
                .format("DD MMM YYYY")
                .toString()
                .toUpperCase(),
              moment(chosenType === "fpi" ? momentFpiDate : momentFirstDataDate)
                .format("DD MMM YYYY")
                .toString()
                .toUpperCase(),
              siteInfo.firstDataParticipant
            )
          });
        }
        barData.categories[0].category.push({ label: siteName });
        data.push({
          country: country,
          site: siteName,
          activeDate: moment(momentActiveDate)
            .format("DD MMM YYYY")
            .toString()
            .toUpperCase(),
          date: moment(chosenType === "fpi" ? momentFpiDate : momentFirstDataDate)
            .format("DD MMM YYYY")
            .toString()
            .toUpperCase(),
          numDays: chosenType === "fpi" ? (isNaN(Number(daysFpi)) ? 0 : daysFpi) : isNaN(Number(daysFirstData)) ? 0 : daysFirstData,
          firstParticipant: chosenType === "fpi" ? 0 : siteInfo.firstDataParticipant
        });
      }
    }
  }
  // Fill total average line
  let totalAvgFpi = Number(Math.round(totalFpiSum / totalValidSites));
  let totalAvgFirstData = Number(Math.round(totalFirstDataSum / totalValidSites));

  totalAvgFpi = isNaN(totalAvgFpi) ? 0 : totalAvgFpi;
  totalAvgFirstData = isNaN(totalAvgFirstData) ? 0 : totalAvgFirstData;
  if (!isSiteStaff) {
    barData.trendlines[0].line.push({
      startvalue: chosenType === "fpi" ? totalAvgFpi : totalAvgFirstData,
      valueOnRight: 1,
      displayvalue: `Average Days ${chosenType === "fpi" ? totalAvgFpi : totalAvgFirstData}`
    });
  }

  barData.chart.yaxisname = "Number of Days";
  barData.chart.xaxisname = "Study Sites";
  // barData.chart.colors[0] = document.querySelector(":root").style.getPropertyValue("--study-primary-color");

  let apexData = _.cloneDeep(barData.dataset[0].data);
  let apexCategories = _.cloneDeep(barData.categories[0].category);
  const lengthData = apexData.length;

  let tmpData = [];

  for (let i = 0; i < lengthData; i++) {
    const data = {
      apexData: apexData[i],
      apexCategories: apexCategories[i],
      activeDate: activeDate[i],
      firstDataDate: firstDataDate[i],
      participantIDs: participantIDs[i]
    };

    tmpData.push(data);
  }

  tmpData = _.orderBy(tmpData, ["apexData.value", "apexCategories"], ["desc", "asc"]);

  apexData = tmpData.map(s => s.apexData);
  apexCategories = tmpData.map(s => s.apexCategories);
  activeDate = tmpData.map(s => {
    return s.activeDate.isValid()
      ? moment(s.activeDate)
          .format("DD MMM YYYY")
          .toString()
          .toUpperCase()
      : "NA";
  });
  firstDataDate = tmpData.map(s => {
    return s.firstDataDate.isValid()
      ? moment(s.firstDataDate)
          .format("DD MMM YYYY")
          .toString()
          .toUpperCase()
      : "NA";
  });
  participantIDs = tmpData.map(s => (s.participantIDs ? s.participantIDs : "NA"));

  barData.dataset[0].data = apexData;
  barData.categories[0].category = apexCategories;

  return {
    apexData: barData,
    data: data
  };
};

export const wrangleFailureAggregation = async (screenFailureRawData = [], countrySelected = [], sitesSelected = []) => {
  const paletteColors = [getPrimaryColorFunc(), "#cab2d6", "#a6cee3", "#fb9a99", "#85c44b"];

  let dataByTotal = [];

  let tmpDataCountries = [];
  let tmpDataSites = [];

  let countrySeries = [];
  let sitesSeries = [];

  const countryLabel = [];
  const sitesLabel = [];

  countrySelected.forEach(countryName => {
    if (countryName in screenFailureRawData) {
      const countryData = screenFailureRawData[countryName];

      sitesSelected.forEach(siteName => {
        if (siteName in countryData) {
          const siteData = countryData[siteName];

          for (const reasons in siteData) {
            const valReasons = siteData[reasons];

            const indexTotal = _.findIndex(dataByTotal, dbt => dbt.label === reasons);

            if (indexTotal > -1) {
              dataByTotal[indexTotal].value += valReasons;
            } else {
              const payload = {
                label: reasons,
                value: valReasons
              };

              dataByTotal.push(payload);
            }
          }
        }
      });
    }
  });

  const orderTotalData = [];
  const orderedData = [];
  const unOrderedData = [];
  const StaticLabels = ["Screen Failure", "Failure to meet Inclusion Criteria", "Failure to meet Exclusion Criteria", "Participant withdrew consent", "Other"];

  // dataByTotal = _.orderBy(dataByTotal, ['value', 'label'], ['desc', 'asc'])

  const highReasons = dataByTotal.length > 0 ? dataByTotal[0].label : "";

  for (let i = 0; i < dataByTotal.length; i++) {
    if (StaticLabels.includes(dataByTotal[i]["label"])) {
      dataByTotal.map(data => {
        if (StaticLabels.includes(data.label)) {
          orderedData.push(data);
        }
      });
    } else {
      unOrderedData.push(dataByTotal[i]);
    }
  }
  dataByTotal = [...orderedData, ...unOrderedData];
  dataByTotal = [...new Map(dataByTotal.map(item =>[item.label, item])).values()];
  for (let i = 0; i < dataByTotal.length; i++) {
    orderTotalData.push(dataByTotal[i]["label"]);
  }

  countrySelected.forEach(countryName => {
    if (countryName in screenFailureRawData) {
      const countryData = screenFailureRawData[countryName];

      sitesSelected.forEach(siteName => {
        if (siteName in countryData) {
          const siteData = countryData[siteName];
          const indexCountries = _.findIndex(tmpDataCountries, c => c.name === countryName);
          const indexSites = _.findIndex(tmpDataSites, s => s.name === siteName);

          if (indexCountries < 0) {
            const valReasons = siteData[highReasons] ? siteData[highReasons] : Number(0);

            const ptc = {
              name: countryName,
              series: [
                {
                  n: highReasons,
                  v: valReasons
                }
              ]
            };

            for (const reasonName in siteData) {
              if (reasonName !== highReasons) {
                const reasonVal = siteData[reasonName] ? siteData[reasonName] : Number(0);
                const seriesCountries = ptc.series;

                const indexSeries = _.findIndex(seriesCountries, ss => ss.n === reasonName);

                if (indexSeries < 0) {
                  const ptcs = { n: reasonName, v: reasonVal };
                  ptc.series.push(ptcs);
                } else {
                  ptc.series[indexSeries]["v"] += reasonVal;
                }
              }
            }

            tmpDataCountries.push(ptc);
          } else {
            for (const reasonName in siteData) {
              if (reasonName !== highReasons) {
                const reasonVal = siteData[reasonName] ? siteData[reasonName] : Number(0);
                const seriesCountry = tmpDataCountries[indexCountries].series;

                const indexSeries = _.findIndex(seriesCountry, sc => sc.n === reasonName);

                if (indexSeries < 0) {
                  const s = {
                    n: reasonName,
                    v: reasonVal
                  };

                  tmpDataCountries[indexCountries].series.push(s);
                } else {
                  tmpDataCountries[indexCountries].series[indexSeries]["v"] += reasonVal;
                }
              } else {
                const reasonVal = siteData[highReasons] ? siteData[highReasons] : Number(0);
                const seriesCountry = tmpDataCountries[indexCountries].series;

                const indexSeries = _.findIndex(seriesCountry, sc => sc.n === highReasons);

                if (indexSeries > -1) {
                  tmpDataCountries[indexCountries].series[indexSeries]["v"] += reasonVal;
                }
              }
            }
          }

          if (indexSites < 0) {
            const valReasons = siteData[highReasons] ? siteData[highReasons] : Number(0);

            const ptc = {
              name: siteName,
              series: [
                {
                  n: highReasons,
                  v: valReasons
                }
              ]
            };

            for (const reasonName in siteData) {
              if (reasonName !== highReasons) {
                const reasonVal = siteData[reasonName] ? siteData[reasonName] : Number(0);
                const seriesSites = ptc.series;

                const indexSeries = _.findIndex(seriesSites, ss => ss.n === reasonName);

                if (indexSeries < 0) {
                  const ptcs = { n: reasonName, v: reasonVal };
                  ptc.series.push(ptcs);
                } else {
                  ptc.series[indexSeries]["v"] += reasonVal;
                }
              }
            }

            tmpDataSites.push(ptc);
          } else {
            for (const reasonName in siteData) {
              if (reasonName !== highReasons) {
                const reasonVal = siteData[reasonName] ? siteData[reasonName] : Number(0);
                const seriesSites = tmpDataSites[indexSites].series;

                const indexSeries = _.findIndex(seriesSites, sc => sc.n === reasonName);

                if (indexSeries < 0) {
                  const s = {
                    n: reasonName,
                    v: reasonVal
                  };

                  tmpDataSites[indexSites].series.push(s);
                } else {
                  tmpDataSites[indexSites].series[indexSeries]["v"] += reasonVal;
                }
              } else {
                const reasonVal = siteData[highReasons] ? siteData[highReasons] : Number(0);
                const seriesSites = tmpDataSites[indexSites].series;

                const indexSeries = _.findIndex(seriesSites, sc => sc.n === highReasons);

                if (indexSeries > -1) {
                  tmpDataSites[indexSites].series[indexSeries]["v"] += reasonVal;
                }
              }
            }
          }
        }
      });
    }
  });

  tmpDataCountries = _.orderBy(tmpDataCountries, [d => d.series[0].v], ["desc"]);
  tmpDataSites = _.orderBy(tmpDataSites, [d => d.series[0].v], ["desc"]);

  for (let i = 0; i < tmpDataCountries.length; i++) {
    const series = tmpDataCountries[i]["series"];
    const label = tmpDataCountries[i]["name"];

    countryLabel.push({ label });

    for (let j = 0; j < series.length; j++) {
      const seriesData = series[j];
      const indexS = _.findIndex(countrySeries, d => d.seriesname === seriesData.n);

      if (indexS > -1) {
        countrySeries[indexS].data[i] = { value: seriesData.v };
      } else {
        const p = {
          seriesname: seriesData.n,
          data: [{ value: seriesData.v }],
          plotToolText: `
            <div class="screen-failure-aggregation-tooltip" style="background-color: ${getPrimaryColorFunc()};">
              <div class="data-label-text">$label</div>
              <div class="data-label-text">$seriesName</div>
              <span class="data-label-text">$dataValue Participants</span>
            </div>
          `
        };
        countrySeries.push(p);
      }
    }
  }

  for (let i = 0; i < tmpDataSites.length; i++) {
    const series = tmpDataSites[i]["series"];
    const label = tmpDataSites[i]["name"];

    sitesLabel.push({ label });

    for (let j = 0; j < series.length; j++) {
      const seriesData = series[j];
      const indexS = _.findIndex(sitesSeries, d => d.seriesname === seriesData.n);

      if (indexS > -1) {
        sitesSeries[indexS].data[i] = { value: seriesData.v };
      } else {
        const p = {
          seriesname: seriesData.n,
          data: [{ value: seriesData.v }],
          plotToolText: `
            <div class="screen-failure-aggregation-tooltip" style="background-color: ${paletteColors[j]};">
              <div class="data-label-text">$label</div>
              <div class="data-label-text">$seriesName</div>
              <span class="data-label-text">$dataValue Participants</span>
            </div>
          `
        };
        sitesSeries.push(p);
      }
    }
  }

  countrySeries = countrySeries.map(({ data, plotToolText, seriesname }) => ({
    data,
    plotToolText,
    seriesname: _.startCase(_.toLower(seriesname))
  }));
  sitesSeries = sitesSeries.map(({ data, plotToolText, seriesname }) => ({
    data,
    plotToolText,
    seriesname: _.startCase(_.toLower(seriesname))
  }));

  const chartConfigs = {
    type: "scrollstackedbar2d",
    width: "100%",
    height: "250",
    dataFormat: "json",
    numVisiblePlot: 5,
    numbersuffix: "M"
  };

  const dataSourceTotal = {
    chart: {
      yAxisName: "Number of Participants",
      theme: "fusion",
      paletteColors: paletteColors.join(","),
      legendPosition: "right",
      legendItemFontSize: "11",
      legendIconScale: "1.7",
      plotToolText: `
          <div class="screen-failure-aggregation-tooltip" style="background-color: ${paletteColors[0]};">
              <span class="data-label-text">$dataValue Participants</span>
          </div>
      `,
      yAxisNameFontSize: "9px",
      yAxisValueFontSize: "10px",
      yAxisValueFontColor: "#a3a3a3",
      yAxisMaxValue: 2,
      labelFontSize: "10px",
      labelFontColor: "#a3a3a3",
      xAxisNameFont: "RobotoRegular",
      xAxisName: "Screen Failure Reason",
      xAxisNameFontSize: "10px",
      labelFont: "RobotoRegular",
      yAxisNameFont: "RobotoRegular",
      yAxisValueFont: "RobotoRegular",
      numVisiblePlot: 5,
      toolTipBorderColor: paletteColors[0],
      toolTipBgAlpha: "100",
      toolTipBgColor: paletteColors[0]
    },
    categories: [
      {
        category: dataByTotal.map(({ label }) => ({ label: label }))
      }
    ],
    dataset: [
      {
        data: dataByTotal.map(({ label, value }) => ({ label: label, value }))
      }
    ]
  };

  const dataSourceCountry = {
    chart: {
      yAxisName: "Participants",
      theme: "fusion",
      paletteColors: paletteColors.join(","),
      legendPosition: "right",
      legendItemFontSize: "11",
      legendIconScale: "1.7",
      yAxisNameFontSize: "9px",
      yAxisValueFontSize: "10px",
      yAxisValueFontColor: "#b0bac9",
      labelFontSize: "12px",
      xAxisNameFont: "RobotoRegular",
      labelFont: "RobotoRegular",
      yAxisNameFont: "RobotoRegular",
      yAxisValueFont: "RobotoRegular",
      numVisiblePlot: 4
    },
    categories: [
      {
        category: countryLabel
      }
    ],
    dataset: countrySeries
  };

  const dataSourceSite = {
    chart: {
      yAxisName: "Participants",
      theme: "fusion",
      paletteColors: paletteColors.join(","),
      legendPosition: "right",
      legendItemFontSize: "11",
      legendIconScale: "1.7",
      yAxisNameFontSize: "9px",
      yAxisValueFontSize: "10px",
      yAxisValueFontColor: "#b0bac9",
      labelFontSize: "12px",
      xAxisNameFont: "RobotoRegular",
      labelFont: "RobotoRegular",
      yAxisNameFont: "RobotoRegular",
      yAxisValueFont: "RobotoRegular",
      numVisiblePlot: 4
    },
    categories: [
      {
        category: sitesLabel
      }
    ],
    dataset: sitesSeries
  };

  return {
    chartConfigs: chartConfigs,
    dataSourceTotal: dataSourceTotal,
    dataSourceCountry: dataSourceCountry,
    dataSourceSite: dataSourceSite
  };
};

export const wrangleConsentDisposition = async (eConsentRawData = [], countrySelected = [], sitesSelected = []) => {
  const paletteColors = ["#5d62b5", "#29c3be", "#f2726f"];

  const dataByTotal = {};

  const mostConsentPayload = [];
  const totalPayload = [];

  const consentBlocks = {
    mostEconsent: 0,
    mostUploaded: 0,
    mostEconsentSite: "",
    mostUploadedSite: "",
    mostUploadedPercentage: 0,
    mostEconsentPercentage: 0
  };

  countrySelected.forEach(countryName => {
    if(eConsentRawData){
      if (countryName in eConsentRawData) {
        const countryData = eConsentRawData[countryName];
        sitesSelected.forEach(siteName => {
          if (siteName in countryData) {
            const siteData = countryData[siteName];
            for (const consentKey in siteData) {
              const siteInfo = siteData[consentKey];
              if (Object.keys(totalPayload).includes(consentKey)) {
                const total = _.reduce(
                  Object.values(siteInfo),
                  function(sum, n) {
                    return sum + n;
                  },
                  0
                );
                totalPayload[consentKey].push({
                  name: siteName,
                  data: siteInfo,
                  total: total
                });
              } else {
                totalPayload[consentKey] = [];
                const total = _.reduce(
                  Object.values(siteInfo),
                  function(sum, n) {
                    return sum + n;
                  },
                  0
                );
                totalPayload[consentKey].push({
                  name: siteName,
                  data: siteInfo,
                  total: total
                });
              }
            }
          }
        });
      }
    }
  });

  const overallConsent = [];
  let totalConsent = 0;

  Object.keys(totalPayload).map(consent => {
    totalPayload[consent].map(data => overallConsent.push(data.data));
  });

  // Doughnut graph data calculation
  overallConsent.forEach(obj => {
    Object.keys(obj).map(key => {
      if (Object.keys(dataByTotal).includes(key)) {
        dataByTotal[key] += parseInt(obj[key]);
        totalConsent += parseInt(obj[key]);
      } else {
        dataByTotal[key] = 0;
        dataByTotal[key] += parseInt(obj[key]);
        totalConsent += parseInt(obj[key]);
      }
    });
  });

  if (mostConsentPayload) {
    Object.keys(totalPayload).map(consent => {
      const sitesDetails = totalPayload[consent].reduce((max, obj) => {
        return max.total > obj.total ? max : obj;
      });
      mostConsentPayload[consent] = {
        site: sitesDetails.name,
        mostConsent: sitesDetails.total
      };
    });
  }

  Object.keys(mostConsentPayload).map(consent => {
    mostConsentPayload[consent].percentage = totalConsent ? ((mostConsentPayload[consent].mostConsent / totalConsent) * 100).toFixed(0) : "";
  });

  if (mostConsentPayload["econsent"]) {
    consentBlocks.mostEconsent = mostConsentPayload["econsent"].mostConsent;
    consentBlocks.mostEconsentPercentage = mostConsentPayload["econsent"].percentage;
    consentBlocks.mostEconsentSite = mostConsentPayload["econsent"].site;
  }

  if (mostConsentPayload["uploaded"]) {
    consentBlocks.mostUploaded = mostConsentPayload["uploaded"].mostConsent;
    consentBlocks.mostUploadedPercentage = mostConsentPayload["uploaded"].percentage;
    consentBlocks.mostUploadedSite = mostConsentPayload["uploaded"].site;
  }

  const labelArr = Object.keys(dataByTotal);
  const result = {};
  for (let i = 0; i < labelArr.length; i++) {
    if (labelArr[i] === "unsigned") {
      result[labelArr[i]] = "Unsigned";
    }
    if (labelArr[i] === "participantSigned") {
      result[labelArr[i]] = "Participant Signed";
    }
    if (labelArr[i] === "piAndParticipantSigned") {
      result[labelArr[i]] = "PI and Participant Signed";
    }
  }

  function renameKeys(dataByTotal, result) {
    const keyValues = Object.keys(dataByTotal).map(key => {
      const newKey = result[key] || key;
      return { [newKey]: dataByTotal[key] };
    });
    return Object.assign({}, ...keyValues);
  }

  const chartData = renameKeys(dataByTotal, result);
  //Doughnut Object creation
  let data = [];
  data = Object.entries(chartData).map(([label, value]) => ({
    label: label,
    value
  }));

  const chartConfigs = {
    height: "250",
    type: "doughnut2d",
    dataFormat: "json",
    width: "100%"
  };

  const dataSource = {
    chart: {
      theme: "fusion",
      defaultCenterLabel: `<strong>Total Consents:</strong> ${totalConsent} `,
      centerLabelFontSize: "13",
      doughnutRadius: "60%",
      pieRadius: "95%",
      centerLabel: "<strong>$label Consent Forms:</strong> $value",
      centerLabelColor: paletteColors[0],
      decimals: "0",
      paletteColors: paletteColors.join(","),
      enablemultislicing: "1",
      plothighlighteffect: "fadeout",
      showlabels: "0",
      showvalues: "0",
      legenditemFontSize: "9px",
      legenditemFont: "RobotoRegular",
      legenditemFontColor: "#a3a3a3",
      labelFontSize: "10px",
      labelFont: "RobotoRegular",
      labelFontColor: "#a3a3a3",
      plottooltext: "$label: $percentvalue",
      showLegend: 1,
      legendBorderColor: "#FFFFFF",
      legendShadow: 0,
      interactiveLegend: 0,
      bgColor: "#FFFFFF",
      legendItemFontSize: "10",
      legendNumRows: "3",
      chartRightMargin: 140,
      legendPosition: "absolute",
      legendxposition: 1500,
      legendyposition: 100
    },
    data: data
  };
  return {
    chartConfigs: chartConfigs,
    dataSource: dataSource,
    consentBlocks: consentBlocks,
    totalConsent: totalConsent
  };
};

export const wrangleQuizComprehensionData = async (filteredRawData, isSiteStaff = false) => {
  const filteredData = filteredRawData;

  const barData = _.cloneDeep(fusionDefaultForBar);
  barData.chart.paletteColors = getPrimaryColorFunc();
  barData.chart.toolTipBgColor = getPrimaryColorFunc();
  barData.chart.toolTipColor = "#ffffff";
  barData.chart.plottooltext = `
    <div class="arrow_box">
      <span class="title-tooltip-custom-apex">$value% Completion</span>
      <div class="wrapper-description">
        <div class="description-value">
          $label
        </div>
      </div>
    </div>`;

  const data = [];
  barData.chart.xaxisname = "Study Sites";
  barData.chart.yaxisname = "Percentage of Completion";
  if (filteredData) {
    Object.entries(filteredData).forEach(byCountry => {
      Object.entries(byCountry[1]).forEach(bySite => {
        const siteName = bySite[0];
        if (bySite[1]) {
          const quizCompletion = bySite[1].quizQompletion;
          const quizAttemps = bySite[1].quizAttempts;
          const quizComprehension = isNaN(quizCompletion / quizAttemps) ? 0 : (quizCompletion / quizAttemps) * 100;
          data.push({
            country: byCountry[0],
            site: siteName,
            total: quizAttemps,
            completed: quizCompletion,
            incompleted: quizAttemps - quizCompletion,
            percentage: quizComprehension.toString() + "%",
            value: Math.round(quizComprehension)
          });
          barData.data = data;
        }
      });
    });
    barData.data = _.orderBy(barData.data, ["value", "site"], ["desc", "asc"]);
    barData.data.forEach(item => {
      barData.dataset[0].data.push({ value: item.value });
      barData.categories[0].category.push({ label: item.site });
    });
  }
  const average =
    barData.dataset[0].data.reduce((accumulator, currentValue) => {
      return accumulator + Number(currentValue.value);
    }, 0) / barData.dataset[0].data.length;

  if (!isSiteStaff) {
    barData.trendlines[0].line.push({
      startvalue: isNaN(average) ? 0 : Math.round(average),
      valueOnRight: 1,
      displayvalue: `Average Completion ${isNaN(average) ? 0 : Math.round(average)}%`
    });
  }
  return barData;
};

export const calculateRecruitmentStats = async (filteredRawData, fromDate = null, toDate = null) => {
  // Temporary data to get summary stats of recruitment
  let fastestFpiDays = Number.MAX_SAFE_INTEGER;
  let earliestFpiDate = moment();
  let fastestFirstDataDays = Number.MAX_SAFE_INTEGER;
  let fastestFpiDate = "";
  let fastestFpiActiveDate = "";
  let fastestFpiSite = null;
  let fastestFpiCountry = null;
  let fastestFirstDataDate = "";
  let fastestFirstDataActiveDate = "";
  let fastestFirstDataSite = null;
  let fastestFirstDataCountry = null;
  let fpiCounter = 0;
  let firstDataCounter = 0;
  let fpiIncludesInDateFilter = true;
  let firstDataIncludesInDateFilter = true;
  for (const country in filteredRawData) {
    const countryName = country;
    for (const site in filteredRawData[country]) {
      const siteName = site;
      const siteInfo = filteredRawData[country][site];
      if (siteInfo) {
        const momentActiveDate = moment(siteInfo.active).startOf("day");
        const momentRealFpiDate = moment(siteInfo.fpi);
        const momentFpiDate = moment(siteInfo.fpi).startOf("day");
        const momentFirstDataDate = moment(siteInfo.firstData).startOf("day");
        const daysFpi = momentFpiDate.diff(momentActiveDate, "days");
        const daysFirstData = momentFirstDataDate.diff(momentActiveDate, "days");
        if (fromDate) {
          const siteActiveIncludesInDateFilter = momentActiveDate.isBetween(fromDate, toDate, "days", "[]");
          if (!siteActiveIncludesInDateFilter) {
            continue;
          }
          fpiIncludesInDateFilter = momentFpiDate.isBetween(fromDate, toDate, "days", "[]");
          firstDataIncludesInDateFilter = momentFirstDataDate.isBetween(fromDate, toDate, "days", "[]");
        }
        if (siteInfo.fpi !== null && fpiIncludesInDateFilter) {
          fpiCounter += 1;
        }
        if (siteInfo.firstData !== null && firstDataIncludesInDateFilter) {
          firstDataCounter += 1;
        }
        if (momentRealFpiDate && fpiIncludesInDateFilter && momentRealFpiDate.isBefore(earliestFpiDate)) {
          fastestFpiDays = daysFpi;
          earliestFpiDate = momentRealFpiDate;
          fastestFpiCountry = countryName;
          fastestFpiDate = momentFpiDate;
          fastestFpiActiveDate = momentActiveDate;
          fastestFpiSite = siteName;
        }
        if (!isNaN(daysFirstData) && firstDataIncludesInDateFilter) {
          if (daysFirstData < fastestFirstDataDays) {
            fastestFirstDataDays = daysFirstData;
            fastestFirstDataCountry = countryName;
            fastestFirstDataDate = momentFirstDataDate;
            fastestFirstDataActiveDate = momentActiveDate;
            fastestFirstDataSite = siteName;
          } else if (daysFirstData === fastestFirstDataDays) {
            // If 2 sites has same diff firstData, it will settled by on earliest site active date
            if (momentActiveDate.isBefore(fastestFirstDataActiveDate)) {
              fastestFirstDataDays = daysFirstData;
              fastestFirstDataCountry = countryName;
              fastestFirstDataDate = momentFirstDataDate;
              fastestFirstDataActiveDate = momentActiveDate;
              fastestFirstDataSite = siteName;
            }
          }
        }
      }
    }
  }

  return {
    totalFpi: fpiCounter,
    totalFirstData: firstDataCounter,
    fastestFpi: {
      days: fastestFpiDays,
      date: fastestFpiDate,
      activeDate: fastestFpiActiveDate,
      site: fastestFpiSite,
      country: fastestFpiCountry
    },
    fastestFirstData: {
      days: fastestFirstDataDays,
      date: fastestFirstDataDate,
      activeDate: fastestFirstDataActiveDate,
      site: fastestFirstDataSite,
      country: fastestFirstDataCountry
    }
  };
};

export const downloadCSV = (titleChart, header, arg, avrg = [], specificSiteId = []) => {
  const today = moment()
    .format("DD MMM YYYY hh:mm:ss")
    .toUpperCase();
  const title = titleChart || "";
  let fileName = title + "_" + today + ".csv";
  if (specificSiteId.length > 0) {
    fileName = title + "_" + today + "_" + getSiteID(specificSiteId[0]) + ".csv";
  }

  arg.splice(0, 0, [title, "", "", "", "", today]);
  arg.splice(1, 0, avrg);
  arg.splice(2, 0, header);

  const csv = papaparse.unparse(arg);

  const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  let csvURL = null;
  if (navigator.msSaveBlob) {
    csvURL = navigator.msSaveBlob(csvData, "download.csv");
  } else {
    csvURL = window.URL.createObjectURL(csvData);
  }
  const tempLink = document.createElement("a");
  tempLink.href = csvURL;
  tempLink.setAttribute("download", fileName);
  tempLink.click();
};

export const generateDataVisualizationForChart = (baseWeekLables = [], dataObject = [], choosenMonth = []) => {
  const returnData = [];
  const weekLabelKeys = dataObject.map(dbj => dbj.x);

  const firstMonth = typeof choosenMonth[0] === "number" ? choosenMonth[0] : convertMonthToTimestampsByMonth(choosenMonth[0]);
  const lastMonth = typeof choosenMonth[1] === "number" ? choosenMonth[1] : convertMonthToTimestampsByMonth(choosenMonth[1]);

  for (let i = 0; i < baseWeekLables.length; i++) {
    const x = baseWeekLables[i];
    const thisMonth = convertMonthToTimestampsByMonth(x);
    if (thisMonth >= firstMonth && thisMonth <= lastMonth) {
      if (weekLabelKeys.includes(x)) {
        const indexDataObject = dataObject.findIndex(ido => ido.x === x);
        const y = dataObject[indexDataObject].y > 0 ? dataObject[indexDataObject].y : 0;
        returnData.push({ value: y });
      } else {
        returnData.push({ value: 0 });
      }
    }
  }

  return returnData;
};

function getPlotToolText() {
  const participantToolTextWithLabel = `<div id="toolTextParticipant">
      <span class="label-top"><b>$label</b></span>
      <span class="data-label-text"><b>$seriesName</b> $dataValue</span>
  </div>`;
  return participantToolTextWithLabel;
}

export const setVisForEnrollmentProgress = (choosenCountries = "all", choosenSites = ["all"], choosenMonth = [], avgUnitTimeByMonthInStudies = null, totalUnitTimeByMonthInStudies = null, locations, initializeWeeks, avgUnitTimeByMonthInCountries) => {
  let dataVisualization = [];
  let setAverageLines = [];
  let numParticipantSites = null;
  const allAverage = [];
  const allTotal = [];
  let countryIndex = 1;
  let siteIndex = 1;

  const firstMonth = convertMonthToTimestampsByMonth(typeof choosenMonth[0] === "string" ? choosenMonth[0] : choosenMonth[0].value);
  const lastMonth = convertMonthToTimestampsByMonth(typeof choosenMonth[0] === "string" ? choosenMonth[1] : choosenMonth[1].value);

  /* ============================================ */
  // Get All Average data base on month selection //
  /* ============================================ */

  if (avgUnitTimeByMonthInStudies) {
    for (const item of avgUnitTimeByMonthInStudies) {
      const thisMonth = convertMonthToTimestampsByMonth(item.x);
      if (thisMonth >= firstMonth && thisMonth <= lastMonth) {
        allAverage.push({ value: item.y });
      }
    }
  }
  if (totalUnitTimeByMonthInStudies) {
    for (const item of totalUnitTimeByMonthInStudies) {
      const thisMonth = convertMonthToTimestampsByMonth(item.x);
      if (thisMonth >= firstMonth && thisMonth <= lastMonth) {
        allTotal.push({ value: item.y });
      }
    }
  }
  // Generate all averages!
  const monthlyAverageArray = {
    seriesname: `Monthly Average`,
    data: allAverage,
    dashed: 6,
    filterType: "all",
    anchorBgColor: "#c4c4c4",
    anchorHoverColor: "#c4c4c4",
    plottooltext: getPlotToolText()
  };
  dataVisualization.push({
    seriesname: `Monthly Total`,
    data: allTotal,
    filterType: "Total",
    anchorBgColor: getPrimaryColorFunc(),
    anchorHoverColor: getPrimaryColorFunc(),
    plottooltext: getPlotToolText()
  });

  let countries = locations ? Object.keys(locations) : [];

  countries = _.orderBy(countries);
  for (const country of countries) {
    if (choosenCountries === "all" || choosenCountries[0] === "all") {
      // Get current country
      const thisCountry = country;

      setAverageLines = avgUnitTimeByMonthInCountries[thisCountry];
      // Generate chart data in selected countries
      const numAverage = generateDataVisualizationForChart(initializeWeeks, setAverageLines, [firstMonth, lastMonth], "average");
      dataVisualization.push({
        seriesname: `${thisCountry === "all" ? "study" : thisCountry}`,
        data: numAverage,
        filterType: "Countries",
        anchorBgColor: lineColor()[countryIndex],
        anchorHoverColor: lineColor()[countryIndex],
        plottooltext: getPlotToolText()
      });
      // Get key of sites
      let sites = Object.keys(locations[thisCountry]);
      sites = _.orderBy(sites);
      for (const site of sites) {
        // Check if sites exist in list choosenSites
        if (choosenSites.includes(site) || choosenSites[0] === "all" || choosenSites === "all") {
          const siteDataParticipant = locations[thisCountry][site];
          numParticipantSites = generateDataVisualizationForChart(initializeWeeks, siteDataParticipant, [firstMonth, lastMonth]);
          dataVisualization.push({
            seriesname: `${site}`,
            data: numParticipantSites,
            filterType: "Sites",
            anchorBgColor: lineColor()[siteIndex],
            anchorHoverColor: lineColor()[siteIndex],
            plottooltext: getPlotToolText()
          });
        }
        siteIndex++;
      }
    } else if (choosenCountries.includes(country)) {
      // Check if countries in list choosenCountries or not
      // Get current country
      const thisCountry = country;
      // Get key of sites
      let sites = Object.keys(locations[thisCountry]);
      sites = _.orderBy(sites);
      // get average from selected countries
      setAverageLines = avgUnitTimeByMonthInCountries[thisCountry];
      // Generate chart data in selected countries
      const numAverage = generateDataVisualizationForChart(initializeWeeks, setAverageLines, [firstMonth, lastMonth], "average");
      dataVisualization.push({
        seriesname: `${thisCountry === "all" ? "study" : thisCountry}`,
        data: numAverage,
        filterType: "Countries",
        anchorBgColor: lineColor()[countryIndex],
        anchorHoverColor: lineColor()[countryIndex],
        plottooltext: getPlotToolText()
      });

      for (const site of sites) {
        // Check if sites exist in list choosenSites
        if (choosenSites.includes(site) || choosenSites[0] === "all" || choosenSites === "all") {
          const siteDataParticipant = locations[thisCountry][site];
          numParticipantSites = generateDataVisualizationForChart(initializeWeeks, siteDataParticipant, [firstMonth, lastMonth]);
          dataVisualization.push({
            seriesname: `${site}`,
            data: numParticipantSites,
            filterType: "Sites",
            anchorBgColor: lineColor()[siteIndex],
            anchorHoverColor: lineColor()[siteIndex],
            plottooltext: getPlotToolText()
          });
        }
        siteIndex++;
      }
    }
    countryIndex++;
  }
  dataVisualization = [monthlyAverageArray].concat(dataVisualization);
  return allAverage.length > 0 ? dataVisualization : [];
};
